import Markdown from 'markdown-to-jsx'
import type React from 'react'

/**
 * Renders an assistant message written in Markdown (bold, lists, links,
 * paragraphs) as React elements. The agent replies in Markdown, but the chat
 * used to dump it as raw text, so `**bold**` and list markers showed literally.
 *
 * markdown-to-jsx renders to React elements (no dangerouslySetInnerHTML) and is
 * tolerant of incomplete Markdown, so a not-yet-closed `**` mid-stream stays
 * literal until its closing token arrives instead of breaking the layout.
 */
const OPTIONS = {
  // Never render raw HTML embedded in the model output — treat it as text.
  disableParsingRawHTMLTags: true,
  overrides: {
    a: { props: { target: '_blank', rel: 'noopener noreferrer' } },
  },
} as const

interface Props {
  children: string
}

export const MarkdownText: React.FC<Props> = ({ children }) => (
  <Markdown options={OPTIONS}>{children}</Markdown>
)
